import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from 'domains/merchant-inbound/molecules/table-column'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.func
  })
}

const defaultProps = {
  hiddenColumns  : [],
  isLoading      : false,
  rowButtonProps : {
    buttonText       : 'Process',
    buttonColour     : 'default',
    onButtonClick    : () => {},
    isButtonDisabled : () => {}
  }
}

/**
 * Table to display Merchant Inbound columns
 * @param {Array<Object>} data - array of merchant_inbound objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const MerchantInboundTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  rowButtonProps,
  isLoading
}) => {
  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    buttonText,
    buttonColour,
    onButtonClick,
    isButtonDisabled
  }),
  [
    buttonColour,
    buttonText,
    onButtonClick,
    isButtonDisabled
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

MerchantInboundTable.propTypes    = propTypes
MerchantInboundTable.defaultProps = defaultProps

export default MerchantInboundTable
